// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7819c342","977":"ea22d1e1"}[chunkId] + ".chunk.js";
};